export const apiStatus = {
  success: 'success',
  idle: 'idle',
  loading: 'loading',
  error: 'error',
}
